import React, { useState, useEffect } from 'react';
import HomePage from './pages/HomePage';
import CameraPage from './pages/CameraPage';
import ViewerPage from './pages/ViewerPage';
import PinPage from './pages/PinPage';
import './App.css';

export default function App() {
  const [mode, setMode] = useState(null);
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const m = params.get('mode');
    if (m === 'camera' || m === 'viewer') setMode(m);
    else setMode('home');

    // Check session
    if (sessionStorage.getItem('sentinel-unlocked')) setUnlocked(true);
  }, []);

  if (!unlocked) return <PinPage onUnlock={() => setUnlocked(true)} />;
  if (mode === 'camera') return <CameraPage onBack={() => setMode('home')} />;
  if (mode === 'viewer') return <ViewerPage onBack={() => setMode('home')} />;
  return <HomePage onSelect={setMode} />;
}
